module.exports = __webpack_public_path__ + "static/media/logo_white_no_text.df5aaa2f.png";